export const enErrorTranslations = {
    ERROR__CAN_NOT_LOAD_THE_COMPONENT: 'Can not load the component',
    ERROR__CAN_NOT_LOAD_WIDGET: 'Try reloading the page or contact support',
    ERROR__SOMETHING_WENT_WRONG: 'Something went wrong',
    ERROR__SOMETHING_WENT_WRONG_DETAILS: 'Please try again later or contact the support team.',
    SERVER_SENDING_DATA_ERROR: 'Error has happend while loading the data',
    ERROR__ACCESS_DENIED_BANNER__TITLE: 'We are sorry, access is restricted',
    ERROR__ACCESS_DENIED_BANNER__SUB_TITLE: 'Contact your administration to obtain access rights',
};
